import React from "react"

const OrganisationDetailsContext = React.createContext({})

const { Provider, Consumer } = OrganisationDetailsContext

export { Provider, Consumer, OrganisationDetailsContext }
